import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, useMediaQuery, Badge } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const GuestFilterTabs = ({
  selectedSide,
  handleSideChange,
  selectedWill,
  handleWillChange,
  arr,
  unArr,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // useStateでfilterCountListを状態として管理
  const [filterCountList, setFilterCountList] = useState({
    all: 0,
    sideGroom: 0,
    sideBride: 0,
    willYes: 0,
    willNo: 0,
    willYet: 0,
  });

  const countGuests = () => {
    console.log(arr);
    console.log(unArr);

    let allCount = 0;
    let sideGroomCount = 0;
    let sideBrideCount = 0;
    let willYesCount = 0;
    let willNoCount = 0;
    let willYetCount = 0;

    // 'arr' 配列内の各アレンジメントについて処理
    arr.forEach((element) => {
      if (element.side === "groom") {
        sideGroomCount += element.guests.length;
      } else if (element.side === "bride") {
        sideBrideCount += element.guests.length;
      } else {
        console.error("Unknown type.");
      }

      // 各ゲストの参加状況をカウント
      element.guests.forEach((guest) => {
        allCount += 1;
        if (guest.will === "yes") {
          willYesCount += 1;
        } else if (guest.will === "no") {
          willNoCount += 1;
        } else if (guest.will === "yet") {
          willYetCount += 1;
        } else {
          console.error("Unknown type.");
        }
      });
    });

    unArr.forEach((guest) => {
      allCount += 1;
      if (guest.side === "groom") {
        sideGroomCount += 1;
      } else if (guest.side === "bride") {
        sideBrideCount += 1;
      } else {
        console.error("Unknown type.");
      }

      if (guest.will === "yes") {
        willYesCount += 1;
      } else if (guest.will === "no") {
        willNoCount += 1;
      } else if (guest.will === "yet") {
        willYetCount += 1;
      } else {
        console.error("Unknown type.");
      }
    });

    // 状態の更新
    setFilterCountList({
      all: allCount,
      sideGroom: sideGroomCount,
      sideBride: sideBrideCount,
      willYes: willYesCount,
      willNo: willNoCount,
      willYet: willYetCount,
    });

    console.log(filterCountList);
  };

  useEffect(() => {
    // コンポーネントがレンダリングされるたびにゲスト数をカウント
    countGuests();
  }, [arr]);

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedSide}
          onChange={handleSideChange}
          aria-label="guest filter tabs"
          textColor="secondary"
          indicatorColor="secondary"
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.primary.main,
              height: "3px",
            },
          }}
        >
          <Tab
            value="all"
            label={
              <Badge color="primary" badgeContent={filterCountList.all}>
                <Box style={{ padding: "0 6px 0 0" }}>全て</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              padding: "0",
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600, // アクティブ時の太さを変更
              },
            }}
          />
          <Tab
            value="groom"
            label={
              <Badge color="primary" badgeContent={filterCountList.sideGroom}>
                <Box style={{ padding: "0 6px 0 0" }}>新郎側</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            }}
          />
          <Tab
            value="bride"
            label={
              <Badge color="primary" badgeContent={filterCountList.sideBride}>
                <Box style={{ padding: "0 6px 0 0" }}>新婦側</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            }}
          />
        </Tabs>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedWill}
          onChange={handleWillChange}
          aria-label="guest filter tabs"
          textColor="secondary"
          indicatorColor="secondary"
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.primary.main,
              height: "3px",
            },
          }}
        >
          <Tab
            value="all"
            label={
              <Badge color="primary" badgeContent={filterCountList.all}>
                <Box style={{ padding: "0 6px 0 0" }}>全て</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            }}
          />
          <Tab
            value="yes"
            label={
              <Badge color="primary" badgeContent={filterCountList.willYes}>
                <Box style={{ padding: "0 6px 0 0" }}>参加</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            }}
          />
          <Tab
            value="no"
            label={
              <Badge color="primary" badgeContent={filterCountList.willNo}>
                <Box style={{ padding: "0 6px 0 0" }}>不参加</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            }}
          />
          <Tab
            value="yet"
            label={
              <Badge color="primary" badgeContent={filterCountList.willYet}>
                <Box style={{ padding: "0 6px 0 0" }}>未定</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px", // 画面幅に応じてminWidthを変更
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 600,
              },
            }}
          />
        </Tabs>
      </Box>
    </>
  );
};

export default GuestFilterTabs;
